<template>
    <div class="feature-image" :style="src ? `background-image: url(${src})` : ''">
        <div v-if="!src" class="drop-message">
            <Icon name="file-horizontal-image" :size="66" />
            <div class="content">
                <h2>{{ $t('event.feature_image.drop_image') }}</h2>
                <p>{{ $t('event.feature_image.or_click_to_select') }}</p>
            </div>
        </div>
        <Button class="btn-edit" type="white" :value="$t('general.edit')" icon="camera" @click="openImageUpload()" />
        <Modal v-if="imageUploadOpen" @cancel="closeImageUpload()">
            <div class="modal-content">
                <div class="title-container">
                    <div class="title copy-l bold">{{ $t('event.feature_image.cover') }}</div>
                    <div class="copy-s">{{ $t('event.feature_image.image_represents_event') }}</div>
                </div>
                <ImageUpload @image="(e) => handleImage(e)" />
                <div class="action-container fullwidth">
                    <Button :value="$t('general.cancel')" type="secondary" @click="closeImageUpload()" />
                    <Button :value="$t('general.save')" type="primary" @click="saveImage()" />
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Icon from '@/components/Icon'
import Button from '@/components/Button'
import ImageUpload from '@/components/ImageUpload'
import Modal from '@/components/Modal'

export default {
    name: 'FeatureImage',
    components: {
        Icon,
        Button,
        ImageUpload,
        Modal,
    },
    props: {
        src: {
            type: String,
        },
    },
    data() {
        return {
            imageSource: this.src,
            imageUploadOpen: false,
            newsrc: '',
        }
    },
    methods: {
        openImageUpload() {
            this.imageUploadOpen = true
        },
        closeImageUpload() {
            this.imageUploadOpen = false
        },
        handleImage(src) {
            this.newsrc = src
        },
        saveImage() {
            this.$emit('image', this.newsrc)
            this.closeImageUpload()
        },
    },
}
</script>

<style scoped lang="sass">
.feature-image
    background-color: $gray-1
    background:
        position: center
        size: cover
    border-radius: $s
    height: 27em
    display: flex
    justify-content: center
    align-items: center
    position: relative

    .btn-edit
        position: absolute
        bottom: $l
        right: $l

    .drop-message
        display: flex
        align-items: center
        flex-direction: column

    .icon
        stroke: #C6C4CF
    .content
        text-align: center
        margin-top: $l
        p
            margin-top: $xs


    .modal
        .modal-content
            .title-container
                display: block
                margin-bottom: $xl

                .copy-s
                    margin-top: $xxs

            .action-container
                margin-top: $xl


//
</style>
